module.exports = __webpack_public_path__ + "img/page.333344a4.svg";